import React, { useContext } from 'react';

import Card, { useThreshold } from './Card';
import TruckIcon from '../common/icons/TruckIcon';
import Img from './elements/Img';
import Prices from './elements/Prices';
import CurrencyContext from '../contexts/CurrencyContext';
import { Offer, Settings } from '../domain';
import RegtriggeringAnimatedCheckmark from './elements/RegtriggeringAnimatedCheckmark';

function getSubtitle(offer: Offer, settings, passed: boolean | undefined) {
  const subtitle = passed
    ? settings.subtitle_condition_met || 'Free shipping'
    : offer.subtitle_condition_not_met || 'to get Free shipping';

  return subtitle.replace('DISPLAYNAME', offer.display_name);
}

export const FreeShippingCardInner = ({ offer }: { offer: Offer }) => {
  const { passed } = useThreshold(offer);
  const currencyCtx = useContext(CurrencyContext);

  return (
    <div
      className="flex gap-4 items-center freeShippingCard"
      data-cy="free-shipping"
    >
      <Img className="bg-gray-50">
        <TruckIcon />
        {passed ? <RegtriggeringAnimatedCheckmark /> : null}
      </Img>
      <div className="GiftBox-Offer-Card-Line flex flex-col justify-center Giftbox-CardProductNameWidth">
        <div className="GiftBox-Offer-Card-Line-Name GiftBox-Offer-Free-Shipping-Name Giftbox-TextOverflowEllipsis">
          {offer.display_name}
        </div>
        <Prices originalPrice={offer.original_price} currency={currencyCtx} />
      </div>
    </div>
  );
};

type Props = {
  offer: Offer;
  settings: Settings;
};

export default ({ offer, settings }: Props) => {
  const { passed } = useThreshold(offer);
  return (
    <Card
      offer={offer}
      subtitle={getSubtitle(offer, settings, passed)}
      isMultipleProduct={false}
    >
      <FreeShippingCardInner offer={offer} />
    </Card>
  );
};
